module.exports = __webpack_public_path__ + "img/1547025416.c0cc6e5a.jpg";